import React from 'react'
import ClinicSurvey from './ClinicSurvey'

function SurveyTab() {
 
    const handleLoadClick = ()=>{

    }
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Clinic Surveys
        </h5>
        <div>
         
        </div>
      </div>
      <ClinicSurvey/>
    </>
  )
}

export default SurveyTab